module.exports = __webpack_public_path__ + "img/512.5176d9ca.png";